import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import './InfoBox.css';

const InfoBox = forwardRef(({ icon, topic, children, variant, outline, card, className, style, ...rest }, ref) => (
    <div
        ref={ref}
        className={`infoBox infoBox--${variant} ${outline ? 'infoBox--outline' : ''} ${card ? 'infoBox--card' : ''} ${className || ''}`}
        style={style}
        {...rest}
    >
        <div className="infoBoxHeader">
            {icon && <i className={`${icon} infoBoxIcon`} aria-hidden="true"></i>}
            {topic && <span className="infoBoxTopic">{topic}</span>}
        </div>
        <div className="infoBoxBody fs12">{children}</div>
    </div>
));

InfoBox.displayName = 'InfoBox';

InfoBox.propTypes = {
    icon: PropTypes.string,
    topic: PropTypes.node,
    children: PropTypes.node,
    variant: PropTypes.oneOf(['primary', 'danger', 'success']),
    outline: PropTypes.bool,
    card: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,
};

InfoBox.defaultProps = {
    variant: 'primary',
    outline: false,
    card: false,
};

export default InfoBox;
